import React, { useEffect, useState } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import SecTitle from "../Common/SecTitle";
import { getBlogs } from "../../services/BlogsService";
import BlogCard from "../Card/BlogCard";
import { Link } from "react-router-dom";
const Blogs = () => {
  const [recentBlogs, setRecentBlogs] = useState([]);

  const getBlogsList = async () => {
    try {
      const data = await getBlogs();
      console.log("latest_blogs", data);
      setRecentBlogs(data.data.latest_blogs);
    } catch (ex) {}
  };
  useEffect(() => {
    getBlogsList();
  }, []);

  return (
    <section className="bg-dark-blue py-1 text-white mt-5">
      <div className="my-5">
        <div className="row mx-0 align-items-center justify-content-center">
          <SecTitle title="بلاگ ها" />
          <div className="col-lg-10 mb-3">
            <Splide
              className="dir_ltr"
              aria-label="My Favorite Images"
              options={{
                rewind: false,
                gap: "1rem",
                perPage: 4,
                breakpoints: {
                  1160: {
                    perPage: 3,
                  },
                  720: {
                    perPage: 2,
                  },
                  440: {
                    perPage: 1,
                  },
                },
                type: "loop",
                pagination: false,
                autoplay: false,
                interval: 10000,
                drag: true,
                easing: "ease",
              }}
            >
              {recentBlogs !== null && recentBlogs.length !== 0
                ? recentBlogs.map((item) => (
                    <SplideSlide key={item.id}>
                      <BlogCard item={item} detailsUrl="blogsDetails" />
                    </SplideSlide>
                  ))
                : ""}
            </Splide>
          </div>
          <Link
            to="/blogs/index"
            className="text-white text-center mb-5"
            style={{ textDecoration: "underline" }}
          >
            بیشتر
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Blogs;
